"use client";

import { useEffect } from "react";
import { initSentry, Sentry } from "@/app/lib/sentry";

function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="text-center">
        <h1 className="text-4xl sm:text-6xl font-black gradient-text mb-4">
          Ups
        </h1>
        <p className="text-lg sm:text-xl text-white/50 mb-8">
          Algo sali&oacute; mal. Estamos trabajando para solucionarlo.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="btn-primary inline-flex"
        >
          Recargar p&aacute;gina
        </button>
      </div>
    </div>
  );
}

export default function SentryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    initSentry();
  }, []);

  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
